import { userOrgApi as api } from './userOrgSlice';
const injectedRtkApi = api.injectEndpoints({
    endpoints: build => ({
        getApiEnumsRequestStates: build.query<GetApiEnumsRequestStatesApiResponse, GetApiEnumsRequestStatesApiArg>({
            query: () => ({ url: `/api/Enums/RequestStates` }),
        }),
        getApiEnumsRequestTypes: build.query<GetApiEnumsRequestTypesApiResponse, GetApiEnumsRequestTypesApiArg>({
            query: () => ({ url: `/api/Enums/RequestTypes` }),
        }),
        getApiEnumsOperationModeResponses: build.query<
            GetApiEnumsOperationModeResponsesApiResponse,
            GetApiEnumsOperationModeResponsesApiArg
        >({
            query: () => ({ url: `/api/Enums/OperationModeResponses` }),
        }),
        getApiHeappeListChangedFilesForJobByProjectShortNameAndResourceNameSubmittedJobInfoId: build.query<
            GetApiHeappeListChangedFilesForJobByProjectShortNameAndResourceNameSubmittedJobInfoIdApiResponse,
            GetApiHeappeListChangedFilesForJobByProjectShortNameAndResourceNameSubmittedJobInfoIdApiArg
        >({
            query: queryArg => ({
                url: `/api/Heappe/ListChangedFilesForJob/${queryArg.projectShortName}/${queryArg.resourceName}/${queryArg.submittedJobInfoId}`,
            }),
        }),
        getApiOtherCountry: build.query<GetApiOtherCountryApiResponse, GetApiOtherCountryApiArg>({
            query: queryArg => ({
                url: `/api/Other/Country`,
                params: {
                    CountryCode: queryArg.countryCode,
                },
            }),
        }),
        getApiOtherStatistics: build.query<GetApiOtherStatisticsApiResponse, GetApiOtherStatisticsApiArg>({
            query: queryArg => ({
                url: `/api/Other/Statistics`,
                params: {
                    fromDate: queryArg.fromDate,
                    toDate: queryArg.toDate,
                },
            }),
        }),
        getApiOtherCyclopsUsageByProjectShortNameAndResourceName: build.query<
            GetApiOtherCyclopsUsageByProjectShortNameAndResourceNameApiResponse,
            GetApiOtherCyclopsUsageByProjectShortNameAndResourceNameApiArg
        >({
            query: queryArg => ({
                url: `/api/Other/CyclopsUsage/${queryArg.projectShortName}/${queryArg.resourceName}`,
                params: {
                    fromDate: queryArg.fromDate,
                    toDate: queryArg.toDate,
                },
            }),
        }),
        getApiProjectByProjectShortNameUsers: build.query<
            GetApiProjectByProjectShortNameUsersApiResponse,
            GetApiProjectByProjectShortNameUsersApiArg
        >({
            query: queryArg => ({ url: `/api/Project/${queryArg.projectShortName}/Users` }),
        }),
        getProject: build.query<GetProjectApiResponse, GetProjectApiArg>({
            query: queryArg => ({
                url: `/api/Project`,
                params: {
                    ProjectShortName: queryArg.projectShortName,
                },
            }),
        }),
        postApiProject: build.mutation<PostApiProjectApiResponse, PostApiProjectApiArg>({
            query: queryArg => ({
                url: `/api/Project`,
                method: 'POST',
                body: queryArg.userOrganizationManagementDomainExtModelsUserOrgInputModelsProjectProjectCreate,
            }),
        }),
        putApiProject: build.mutation<PutApiProjectApiResponse, PutApiProjectApiArg>({
            query: queryArg => ({
                url: `/api/Project`,
                method: 'PUT',
                body: queryArg.userOrganizationManagementDomainExtModelsUserOrgInputModelsProjectProjectUpdate,
            }),
        }),
        putApiProjectByProjectShortNameUserAndIdpUserIdAssignRoleId: build.mutation<
            PutApiProjectByProjectShortNameUserAndIdpUserIdAssignRoleIdApiResponse,
            PutApiProjectByProjectShortNameUserAndIdpUserIdAssignRoleIdApiArg
        >({
            query: queryArg => ({
                url: `/api/Project/${queryArg.projectShortName}/User/${queryArg.idpUserId}/Assign/${queryArg.roleId}`,
                method: 'PUT',
            }),
        }),
        deleteApiProjectByProjectShortName: build.mutation<
            DeleteApiProjectByProjectShortNameApiResponse,
            DeleteApiProjectByProjectShortNameApiArg
        >({
            query: queryArg => ({ url: `/api/Project/${queryArg.projectShortName}`, method: 'DELETE' }),
        }),
        putApiProjectByProjectShortNameProjectResourceAndProjectResourceName: build.mutation<
            PutApiProjectByProjectShortNameProjectResourceAndProjectResourceNameApiResponse,
            PutApiProjectByProjectShortNameProjectResourceAndProjectResourceNameApiArg
        >({
            query: queryArg => ({
                url: `/api/Project/${queryArg.projectShortName}/ProjectResource/${queryArg.projectResourceName}`,
                method: 'PUT',
            }),
        }),
        deleteApiProjectByProjectShortNameProjectResourceAndProjectResourceName: build.mutation<
            DeleteApiProjectByProjectShortNameProjectResourceAndProjectResourceNameApiResponse,
            DeleteApiProjectByProjectShortNameProjectResourceAndProjectResourceNameApiArg
        >({
            query: queryArg => ({
                url: `/api/Project/${queryArg.projectShortName}/ProjectResource/${queryArg.projectResourceName}`,
                method: 'DELETE',
            }),
        }),
        putApiProjectByProjectShortNameUserAndIdpUserId: build.mutation<
            PutApiProjectByProjectShortNameUserAndIdpUserIdApiResponse,
            PutApiProjectByProjectShortNameUserAndIdpUserIdApiArg
        >({
            query: queryArg => ({
                url: `/api/Project/${queryArg.projectShortName}/User/${queryArg.idpUserId}`,
                method: 'PUT',
            }),
        }),
        deleteApiProjectByProjectShortNameUserAndIdpUserId: build.mutation<
            DeleteApiProjectByProjectShortNameUserAndIdpUserIdApiResponse,
            DeleteApiProjectByProjectShortNameUserAndIdpUserIdApiArg
        >({
            query: queryArg => ({
                url: `/api/Project/${queryArg.projectShortName}/User/${queryArg.idpUserId}`,
                method: 'DELETE',
            }),
        }),
        putApiProjectByProjectShortNameProjectTagAndProjectTagId: build.mutation<
            PutApiProjectByProjectShortNameProjectTagAndProjectTagIdApiResponse,
            PutApiProjectByProjectShortNameProjectTagAndProjectTagIdApiArg
        >({
            query: queryArg => ({
                url: `/api/Project/${queryArg.projectShortName}/ProjectTag/${queryArg.projectTagId}`,
                method: 'PUT',
            }),
        }),
        deleteApiProjectByProjectShortNameProjectTagAndProjectTagId: build.mutation<
            DeleteApiProjectByProjectShortNameProjectTagAndProjectTagIdApiResponse,
            DeleteApiProjectByProjectShortNameProjectTagAndProjectTagIdApiArg
        >({
            query: queryArg => ({
                url: `/api/Project/${queryArg.projectShortName}/ProjectTag/${queryArg.projectTagId}`,
                method: 'DELETE',
            }),
        }),
        templatesInfo: build.query<TemplatesInfoApiResponse, TemplatesInfoApiArg>({
            query: queryArg => ({ url: `/api/Project/TemplatesInfo/${queryArg.projectShortName}` }),
        }),
        extendedProjectInfo: build.query<ExtendedProjectInfoApiResponse, ExtendedProjectInfoApiArg>({
            query: queryArg => ({
                url: `/api/Project/ExtendedProjectInfo`,
                params: {
                    ProjectShortName: queryArg.projectShortName,
                },
            }),
        }),
        validRoles: build.query<ValidRolesApiResponse, ValidRolesApiArg>({
            query: queryArg => ({ url: `/api/Project/${queryArg.projectShortName}/ValidRoles` }),
        }),
        getApiProjectResourceAssignment: build.query<
            GetApiProjectResourceAssignmentApiResponse,
            GetApiProjectResourceAssignmentApiArg
        >({
            query: queryArg => ({
                url: `/api/ProjectResourceAssignment`,
                params: {
                    ProjectResourceId: queryArg.projectResourceId,
                },
            }),
        }),
        postApiProjectResourceAssignment: build.mutation<
            PostApiProjectResourceAssignmentApiResponse,
            PostApiProjectResourceAssignmentApiArg
        >({
            query: queryArg => ({
                url: `/api/ProjectResourceAssignment`,
                method: 'POST',
                body: queryArg.userOrganizationManagementDomainExtModelsUserOrgInputModelsProjectResourceAssignmentProjectResourceAssignmentCreate,
            }),
        }),
        putApiProjectResourceAssignment: build.mutation<
            PutApiProjectResourceAssignmentApiResponse,
            PutApiProjectResourceAssignmentApiArg
        >({
            query: queryArg => ({
                url: `/api/ProjectResourceAssignment`,
                method: 'PUT',
                body: queryArg.userOrganizationManagementDomainExtModelsUserOrgInputModelsProjectResourceAssignmentProjectResourceAssignmentUpdate,
            }),
        }),
        getProjectResourceAssignment: build.query<
            GetProjectResourceAssignmentApiResponse,
            GetProjectResourceAssignmentApiArg
        >({
            query: queryArg => ({ url: `/api/ProjectResourceAssignment/${queryArg.id}` }),
        }),
        deleteApiProjectResourceAssignmentById: build.mutation<
            DeleteApiProjectResourceAssignmentByIdApiResponse,
            DeleteApiProjectResourceAssignmentByIdApiArg
        >({
            query: queryArg => ({ url: `/api/ProjectResourceAssignment/${queryArg.id}`, method: 'DELETE' }),
        }),
        getApiProjectResource: build.query<GetApiProjectResourceApiResponse, GetApiProjectResourceApiArg>({
            query: queryArg => ({
                url: `/api/ProjectResource`,
                params: {
                    ProjectShortName: queryArg.projectShortName,
                    LocationTypeId: queryArg.locationTypeId,
                    StartDate: queryArg.startDate,
                    EndDate: queryArg.endDate,
                },
            }),
        }),
        postApiProjectResource: build.mutation<PostApiProjectResourceApiResponse, PostApiProjectResourceApiArg>({
            query: queryArg => ({
                url: `/api/ProjectResource`,
                method: 'POST',
                body: queryArg.userOrganizationManagementDomainExtModelsUserOrgInputModelsProjectResourceProjectResourceCreate,
            }),
        }),
        putApiProjectResource: build.mutation<PutApiProjectResourceApiResponse, PutApiProjectResourceApiArg>({
            query: queryArg => ({
                url: `/api/ProjectResource`,
                method: 'PUT',
                body: queryArg.userOrganizationManagementDomainExtModelsUserOrgInputModelsProjectResourceProjectResourceUpdate,
            }),
        }),
        getProjectResource: build.query<GetProjectResourceApiResponse, GetProjectResourceApiArg>({
            query: queryArg => ({ url: `/api/ProjectResource/${queryArg.id}` }),
        }),
        deleteApiProjectResourceById: build.mutation<
            DeleteApiProjectResourceByIdApiResponse,
            DeleteApiProjectResourceByIdApiArg
        >({
            query: queryArg => ({ url: `/api/ProjectResource/${queryArg.id}`, method: 'DELETE' }),
        }),
        getApiProjectTag: build.query<GetApiProjectTagApiResponse, GetApiProjectTagApiArg>({
            query: queryArg => ({
                url: `/api/ProjectTag`,
                params: {
                    TagName: queryArg.tagName,
                },
            }),
        }),
        postApiProjectTag: build.mutation<PostApiProjectTagApiResponse, PostApiProjectTagApiArg>({
            query: queryArg => ({
                url: `/api/ProjectTag`,
                method: 'POST',
                body: queryArg.userOrganizationManagementDomainExtModelsUserOrgInputModelsProjectTagProjectTagCreate,
            }),
        }),
        putApiProjectTag: build.mutation<PutApiProjectTagApiResponse, PutApiProjectTagApiArg>({
            query: queryArg => ({
                url: `/api/ProjectTag`,
                method: 'PUT',
                body: queryArg.userOrganizationManagementDomainExtModelsUserOrgInputModelsProjectTagProjectTagUpdate,
            }),
        }),
        getProjectTag: build.query<GetProjectTagApiResponse, GetProjectTagApiArg>({
            query: queryArg => ({ url: `/api/ProjectTag/${queryArg.id}` }),
        }),
        deleteApiProjectTagById: build.mutation<DeleteApiProjectTagByIdApiResponse, DeleteApiProjectTagByIdApiArg>({
            query: queryArg => ({ url: `/api/ProjectTag/${queryArg.id}`, method: 'DELETE' }),
        }),
        getApiRequests: build.query<GetApiRequestsApiResponse, GetApiRequestsApiArg>({
            query: queryArg => ({
                url: `/api/Requests`,
                params: {
                    State: queryArg.state,
                    Type: queryArg['type'],
                    ProjectShortName: queryArg.projectShortName,
                },
            }),
        }),
        postApiRequests: build.mutation<PostApiRequestsApiResponse, PostApiRequestsApiArg>({
            query: queryArg => ({
                url: `/api/Requests`,
                method: 'POST',
                body: queryArg.userOrganizationManagementDomainExtModelsUserOrgInputModelsProjectRequestCreate,
            }),
        }),
        getApiRequestsSentRequests: build.query<
            GetApiRequestsSentRequestsApiResponse,
            GetApiRequestsSentRequestsApiArg
        >({
            query: queryArg => ({
                url: `/api/Requests/SentRequests`,
                params: {
                    State: queryArg.state,
                    Type: queryArg['type'],
                    ProjectShortName: queryArg.projectShortName,
                },
            }),
        }),
        putApiRequestsByRequestIdAccept: build.mutation<
            PutApiRequestsByRequestIdAcceptApiResponse,
            PutApiRequestsByRequestIdAcceptApiArg
        >({
            query: queryArg => ({ url: `/api/Requests/${queryArg.requestId}/Accept`, method: 'PUT' }),
        }),
        putApiRequestsByRequestIdReject: build.mutation<
            PutApiRequestsByRequestIdRejectApiResponse,
            PutApiRequestsByRequestIdRejectApiArg
        >({
            query: queryArg => ({
                url: `/api/Requests/${queryArg.requestId}/Reject`,
                method: 'PUT',
                params: {
                    Reason: queryArg.reason,
                },
            }),
        }),
        getApiUserPreferences: build.query<GetApiUserPreferencesApiResponse, GetApiUserPreferencesApiArg>({
            query: () => ({ url: `/api/User/Preferences` }),
        }),
        putApiUserPreferences: build.mutation<PutApiUserPreferencesApiResponse, PutApiUserPreferencesApiArg>({
            query: queryArg => ({
                url: `/api/User/Preferences`,
                method: 'PUT',
                body: queryArg.systemTextJsonJsonElement,
            }),
        }),
        getApiUserInfo: build.query<GetApiUserInfoApiResponse, GetApiUserInfoApiArg>({
            query: () => ({ url: `/api/UserInfo` }),
        }),
        getApiUserInfoExtended: build.query<GetApiUserInfoExtendedApiResponse, GetApiUserInfoExtendedApiArg>({
            query: () => ({ url: `/api/UserInfo/Extended` }),
        }),
        syncDetails: build.query<SyncDetailsApiResponse, SyncDetailsApiArg>({
            query: () => ({ url: `/api/Service/SyncDetails` }),
        }),
        projectsInfo: build.query<ProjectsInfoApiResponse, ProjectsInfoApiArg>({
            query: () => ({ url: `/api/Service/ProjectsInfo` }),
        }),
        workerData: build.query<WorkerDataApiResponse, WorkerDataApiArg>({
            query: () => ({ url: `/api/DataStaging/WorkerData` }),
        }),
        postApiPublicHandleByActionLink: build.mutation<
            PostApiPublicHandleByActionLinkApiResponse,
            PostApiPublicHandleByActionLinkApiArg
        >({
            query: queryArg => ({ url: `/api/Public/Handle/${queryArg.actionLink}`, method: 'POST' }),
        }),
        getApiPublicRequestInfoByRequestId: build.query<
            GetApiPublicRequestInfoByRequestIdApiResponse,
            GetApiPublicRequestInfoByRequestIdApiArg
        >({
            query: queryArg => ({ url: `/api/Public/RequestInfo/${queryArg.requestId}` }),
        }),
        getVersion: build.query<GetVersionApiResponse, GetVersionApiArg>({
            query: () => ({ url: `/api/version` }),
        }),
        getCommandTemplatePermissions: build.query<
            GetCommandTemplatePermissionsApiResponse,
            GetCommandTemplatePermissionsApiArg
        >({
            query: queryArg => ({ url: `/api/Heappe/CommandTemplatePermissions/${queryArg.heappeIdentifier}` }),
        }),
        getCommandTemplates: build.query<GetCommandTemplatesApiResponse, GetCommandTemplatesApiArg>({
            query: queryArg => ({
                url: `/api/Heappe/CommandTemplate/${queryArg.projectShortName}/${queryArg.projectResourceName}`,
            }),
        }),
        activateCommandTemplate: build.mutation<ActivateCommandTemplateApiResponse, ActivateCommandTemplateApiArg>({
            query: queryArg => ({
                url: `/api/Heappe/CommandTemplate/Activate`,
                method: 'PUT',
                body: queryArg.heappeFeaturesCommandTemplateManagementRequestCommandTemplateActivateRequest,
            }),
        }),
        deactivateCommandTemplate: build.mutation<
            DeactivateCommandTemplateApiResponse,
            DeactivateCommandTemplateApiArg
        >({
            query: queryArg => ({
                url: `/api/Heappe/CommandTemplate/Deactivate`,
                method: 'PUT',
                body: queryArg.heappeFeaturesCommandTemplateManagementRequestCommandTemplateActivateRequest,
            }),
        }),
        syncCommandTemplate: build.mutation<SyncCommandTemplateApiResponse, SyncCommandTemplateApiArg>({
            query: queryArg => ({
                url: `/api/Heappe/CommandTemplate/Synchronization`,
                method: 'POST',
                body: queryArg.heappeFeaturesCommandTemplateSynchronizationRequestCommandTemplateSyncRequest,
            }),
        }),
        migrate: build.mutation<MigrateApiResponse, MigrateApiArg>({
            query: queryArg => ({
                url: `/api/Heappe/migrate`,
                method: 'POST',
                params: {
                    ProjectShortName: queryArg.projectShortName,
                    DryRun: queryArg.dryRun,
                },
            }),
        }),
    }),
    overrideExisting: false,
});
export { injectedRtkApi as userOrg };
export type GetApiEnumsRequestStatesApiResponse =
    /** status 200 OK */ SystemCollectionsGenericIEnumerable601SystemObject20SystemPrivateCoreLib20Version1000020CultureNeutral20PublicKeyToken7Cec85D7Bea7798E;
export type GetApiEnumsRequestStatesApiArg = void;
export type GetApiEnumsRequestTypesApiResponse =
    /** status 200 OK */ SystemCollectionsGenericIEnumerable601SystemObject20SystemPrivateCoreLib20Version1000020CultureNeutral20PublicKeyToken7Cec85D7Bea7798E;
export type GetApiEnumsRequestTypesApiArg = void;
export type GetApiEnumsOperationModeResponsesApiResponse =
    /** status 200 OK */ SystemCollectionsGenericIEnumerable601SystemObject20SystemPrivateCoreLib20Version1000020CultureNeutral20PublicKeyToken7Cec85D7Bea7798E;
export type GetApiEnumsOperationModeResponsesApiArg = void;
export type GetApiHeappeListChangedFilesForJobByProjectShortNameAndResourceNameSubmittedJobInfoIdApiResponse =
    /** status 200 OK */ SystemCollectionsGenericIDictionary602SystemString20SystemPrivateCoreLib20Version1000020CultureNeutral20PublicKeyToken7Cec85D7Bea7798EHeappeContractsDownloadedFileModel20HeappeContracts20Version600020CultureNeutral20PublicKeyTokenNull;
export type GetApiHeappeListChangedFilesForJobByProjectShortNameAndResourceNameSubmittedJobInfoIdApiArg = {
    projectShortName: UserOrganizationManagementDomainValueObjectsProjectShortName;
    submittedJobInfoId: SystemInt64;
    resourceName: SystemString;
};
export type GetApiOtherCountryApiResponse =
    /** status 200 OK */ SystemCollectionsGenericIEnumerable601UserOrganizationManagementDomainExtModelsUserOrgOutputModelsOthersCountryModel20Domain20Version600020CultureNeutral20PublicKeyTokenNull;
export type GetApiOtherCountryApiArg = {
    countryCode?: SystemString;
};
export type GetApiOtherStatisticsApiResponse =
    /** status 200 OK */ SystemCollectionsGenericIEnumerable601UserOrganizationManagementDomainExtModelsUserOrgOutputModelsOthersStatisticsModel20Domain20Version600020CultureNeutral20PublicKeyTokenNull;
export type GetApiOtherStatisticsApiArg = {
    fromDate?: SystemNullable601SystemDateOnly20SystemPrivateCoreLib20Version1000020CultureNeutral20PublicKeyToken7Cec85D7Bea7798E;
    toDate?: SystemNullable601SystemDateOnly20SystemPrivateCoreLib20Version1000020CultureNeutral20PublicKeyToken7Cec85D7Bea7798E;
};
export type GetApiOtherCyclopsUsageByProjectShortNameAndResourceNameApiResponse = unknown;
export type GetApiOtherCyclopsUsageByProjectShortNameAndResourceNameApiArg = {
    fromDate?: SystemNullable601SystemDateOnly20SystemPrivateCoreLib20Version1000020CultureNeutral20PublicKeyToken7Cec85D7Bea7798E;
    toDate?: SystemNullable601SystemDateOnly20SystemPrivateCoreLib20Version1000020CultureNeutral20PublicKeyToken7Cec85D7Bea7798E;
    projectShortName: UserOrganizationManagementDomainValueObjectsProjectShortName;
    resourceName: SystemString;
};
export type GetApiProjectByProjectShortNameUsersApiResponse =
    /** status 200 OK */ SystemCollectionsGenericIEnumerable601UserOrganizationManagementDomainExtModelsUserOrgOutputModelsProjectProjectUserModel20Domain20Version600020CultureNeutral20PublicKeyTokenNull;
export type GetApiProjectByProjectShortNameUsersApiArg = {
    projectShortName: UserOrganizationManagementDomainValueObjectsProjectShortName;
};
export type GetProjectApiResponse =
    /** status 200 OK */ SystemCollectionsGenericList601UserOrganizationManagementDomainExtModelsUserOrgOutputModelsProjectProjectModel20Domain20Version600020CultureNeutral20PublicKeyTokenNull;
export type GetProjectApiArg = {
    projectShortName?: SystemNullable601UserOrganizationManagementDomainValueObjectsProjectShortName20Domain20Version600020CultureNeutral20PublicKeyTokenNull;
};
export type PostApiProjectApiResponse = unknown;
export type PostApiProjectApiArg = {
    userOrganizationManagementDomainExtModelsUserOrgInputModelsProjectProjectCreate: UserOrganizationManagementDomainExtModelsUserOrgInputModelsProjectProjectCreate;
};
export type PutApiProjectApiResponse = unknown;
export type PutApiProjectApiArg = {
    userOrganizationManagementDomainExtModelsUserOrgInputModelsProjectProjectUpdate: UserOrganizationManagementDomainExtModelsUserOrgInputModelsProjectProjectUpdate;
};
export type PutApiProjectByProjectShortNameUserAndIdpUserIdAssignRoleIdApiResponse = unknown;
export type PutApiProjectByProjectShortNameUserAndIdpUserIdAssignRoleIdApiArg = {
    projectShortName: UserOrganizationManagementDomainValueObjectsProjectShortName;
    idpUserId: SystemString;
    roleId: SystemInt32;
};
export type DeleteApiProjectByProjectShortNameApiResponse = unknown;
export type DeleteApiProjectByProjectShortNameApiArg = {
    projectShortName: UserOrganizationManagementDomainValueObjectsProjectShortName;
};
export type PutApiProjectByProjectShortNameProjectResourceAndProjectResourceNameApiResponse = unknown;
export type PutApiProjectByProjectShortNameProjectResourceAndProjectResourceNameApiArg = {
    projectShortName: UserOrganizationManagementDomainValueObjectsProjectShortName;
    projectResourceName: SystemString;
};
export type DeleteApiProjectByProjectShortNameProjectResourceAndProjectResourceNameApiResponse = unknown;
export type DeleteApiProjectByProjectShortNameProjectResourceAndProjectResourceNameApiArg = {
    projectShortName: UserOrganizationManagementDomainValueObjectsProjectShortName;
    projectResourceName: SystemString;
};
export type PutApiProjectByProjectShortNameUserAndIdpUserIdApiResponse = unknown;
export type PutApiProjectByProjectShortNameUserAndIdpUserIdApiArg = {
    projectShortName: UserOrganizationManagementDomainValueObjectsProjectShortName;
    idpUserId: SystemString;
};
export type DeleteApiProjectByProjectShortNameUserAndIdpUserIdApiResponse = unknown;
export type DeleteApiProjectByProjectShortNameUserAndIdpUserIdApiArg = {
    projectShortName: UserOrganizationManagementDomainValueObjectsProjectShortName;
    idpUserId: SystemString;
};
export type PutApiProjectByProjectShortNameProjectTagAndProjectTagIdApiResponse = unknown;
export type PutApiProjectByProjectShortNameProjectTagAndProjectTagIdApiArg = {
    projectShortName: UserOrganizationManagementDomainValueObjectsProjectShortName;
    projectTagId: SystemGuid;
};
export type DeleteApiProjectByProjectShortNameProjectTagAndProjectTagIdApiResponse = unknown;
export type DeleteApiProjectByProjectShortNameProjectTagAndProjectTagIdApiArg = {
    projectShortName: UserOrganizationManagementDomainValueObjectsProjectShortName;
    projectTagId: SystemGuid;
};
export type TemplatesInfoApiResponse =
    /** status 200 OK */ SystemCollectionsGenericList601UserOrganizationManagementDomainExtModelsUserOrgOutputModelsProjectTemplateInfoResponse20Domain20Version600020CultureNeutral20PublicKeyTokenNull;
export type TemplatesInfoApiArg = {
    projectShortName: UserOrganizationManagementDomainValueObjectsProjectShortName;
};
export type ExtendedProjectInfoApiResponse =
    /** status 200 OK */ SystemCollectionsGenericList601UserOrganizationManagementDomainExtModelsUserOrgOutputModelsProjectExtendedProjectModel20Domain20Version600020CultureNeutral20PublicKeyTokenNull;
export type ExtendedProjectInfoApiArg = {
    projectShortName: UserOrganizationManagementDomainValueObjectsProjectShortName;
};
export type ValidRolesApiResponse =
    /** status 200 OK */ SystemCollectionsGenericList601UserOrganizationManagementDomainExtModelsUserOrgOutputModelsSystemRoleManagementSystemRoleModel20Domain20Version600020CultureNeutral20PublicKeyTokenNull;
export type ValidRolesApiArg = {
    projectShortName: UserOrganizationManagementDomainValueObjectsProjectShortName;
};
export type GetApiProjectResourceAssignmentApiResponse =
    /** status 200 OK */ SystemCollectionsGenericIEnumerable601UserOrganizationManagementDomainExtModelsUserOrgOutputModelsProjectResourceAssignmentProjectResourceAssignmentModel20Domain20Version600020CultureNeutral20PublicKeyTokenNull;
export type GetApiProjectResourceAssignmentApiArg = {
    projectResourceId?: SystemNullable601SystemGuid20SystemPrivateCoreLib20Version1000020CultureNeutral20PublicKeyToken7Cec85D7Bea7798E;
};
export type PostApiProjectResourceAssignmentApiResponse = unknown;
export type PostApiProjectResourceAssignmentApiArg = {
    userOrganizationManagementDomainExtModelsUserOrgInputModelsProjectResourceAssignmentProjectResourceAssignmentCreate: UserOrganizationManagementDomainExtModelsUserOrgInputModelsProjectResourceAssignmentProjectResourceAssignmentCreate;
};
export type PutApiProjectResourceAssignmentApiResponse = unknown;
export type PutApiProjectResourceAssignmentApiArg = {
    userOrganizationManagementDomainExtModelsUserOrgInputModelsProjectResourceAssignmentProjectResourceAssignmentUpdate: UserOrganizationManagementDomainExtModelsUserOrgInputModelsProjectResourceAssignmentProjectResourceAssignmentUpdate;
};
export type GetProjectResourceAssignmentApiResponse =
    /** status 200 OK */ UserOrganizationManagementDomainExtModelsUserOrgOutputModelsProjectResourceAssignmentProjectResourceAssignmentModel;
export type GetProjectResourceAssignmentApiArg = {
    id: SystemGuid;
};
export type DeleteApiProjectResourceAssignmentByIdApiResponse = unknown;
export type DeleteApiProjectResourceAssignmentByIdApiArg = {
    id: SystemGuid;
};
export type GetApiProjectResourceApiResponse =
    /** status 200 OK */ SystemCollectionsGenericIEnumerable601UserOrganizationManagementDomainExtModelsUserOrgOutputModelsProjectResourceProjectResourceModel20Domain20Version600020CultureNeutral20PublicKeyTokenNull;
export type GetApiProjectResourceApiArg = {
    projectShortName?: SystemNullable601UserOrganizationManagementDomainValueObjectsProjectShortName20Domain20Version600020CultureNeutral20PublicKeyTokenNull;
    locationTypeId?: SystemNullable601SystemInt3220SystemPrivateCoreLib20Version1000020CultureNeutral20PublicKeyToken7Cec85D7Bea7798E;
    startDate?: SystemNullable601SystemDateTime20SystemPrivateCoreLib20Version1000020CultureNeutral20PublicKeyToken7Cec85D7Bea7798E;
    endDate?: SystemNullable601SystemDateTime20SystemPrivateCoreLib20Version1000020CultureNeutral20PublicKeyToken7Cec85D7Bea7798E;
};
export type PostApiProjectResourceApiResponse = unknown;
export type PostApiProjectResourceApiArg = {
    userOrganizationManagementDomainExtModelsUserOrgInputModelsProjectResourceProjectResourceCreate: UserOrganizationManagementDomainExtModelsUserOrgInputModelsProjectResourceProjectResourceCreate;
};
export type PutApiProjectResourceApiResponse = unknown;
export type PutApiProjectResourceApiArg = {
    userOrganizationManagementDomainExtModelsUserOrgInputModelsProjectResourceProjectResourceUpdate: UserOrganizationManagementDomainExtModelsUserOrgInputModelsProjectResourceProjectResourceUpdate;
};
export type GetProjectResourceApiResponse =
    /** status 200 OK */ UserOrganizationManagementDomainExtModelsUserOrgOutputModelsProjectResourceProjectResourceModel;
export type GetProjectResourceApiArg = {
    id: SystemGuid;
};
export type DeleteApiProjectResourceByIdApiResponse = unknown;
export type DeleteApiProjectResourceByIdApiArg = {
    id: SystemGuid;
};
export type GetApiProjectTagApiResponse =
    /** status 200 OK */ SystemCollectionsGenericIEnumerable601UserOrganizationManagementDomainExtModelsUserOrgOutputModelsProjectTagProjectTagModel20Domain20Version600020CultureNeutral20PublicKeyTokenNull;
export type GetApiProjectTagApiArg = {
    tagName?: SystemString;
};
export type PostApiProjectTagApiResponse = unknown;
export type PostApiProjectTagApiArg = {
    userOrganizationManagementDomainExtModelsUserOrgInputModelsProjectTagProjectTagCreate: UserOrganizationManagementDomainExtModelsUserOrgInputModelsProjectTagProjectTagCreate;
};
export type PutApiProjectTagApiResponse = unknown;
export type PutApiProjectTagApiArg = {
    userOrganizationManagementDomainExtModelsUserOrgInputModelsProjectTagProjectTagUpdate: UserOrganizationManagementDomainExtModelsUserOrgInputModelsProjectTagProjectTagUpdate;
};
export type GetProjectTagApiResponse =
    /** status 200 OK */ UserOrganizationManagementDomainExtModelsUserOrgOutputModelsProjectTagProjectTagModel;
export type GetProjectTagApiArg = {
    id: SystemGuid;
};
export type DeleteApiProjectTagByIdApiResponse = unknown;
export type DeleteApiProjectTagByIdApiArg = {
    id: SystemGuid;
};
export type GetApiRequestsApiResponse = /** status 200 OK */
    | SystemCollectionsGenericList601UserOrganizationManagementDomainExtModelsUserOrgOutputModelsRequestRequestModel20Domain20Version600020CultureNeutral20PublicKeyTokenNull
    | /** status 204 No Content */ MicrosoftAspNetCoreMvcProblemDetails;
export type GetApiRequestsApiArg = {
    state?: SystemNullable601UserOrganizationManagementDomainEnumsERequestState20Domain20Version600020CultureNeutral20PublicKeyTokenNull;
    type?: SystemNullable601UserOrganizationManagementDomainEnumsERequestType20Domain20Version600020CultureNeutral20PublicKeyTokenNull;
    projectShortName?: SystemNullable601UserOrganizationManagementDomainValueObjectsProjectShortName20Domain20Version600020CultureNeutral20PublicKeyTokenNull;
};
export type PostApiRequestsApiResponse = unknown;
export type PostApiRequestsApiArg = {
    userOrganizationManagementDomainExtModelsUserOrgInputModelsProjectRequestCreate: UserOrganizationManagementDomainExtModelsUserOrgInputModelsProjectRequestCreate;
};
export type GetApiRequestsSentRequestsApiResponse = /** status 200 OK */
    | SystemCollectionsGenericList601UserOrganizationManagementDomainExtModelsUserOrgOutputModelsRequestRequestModel20Domain20Version600020CultureNeutral20PublicKeyTokenNull
    | /** status 204 No Content */ MicrosoftAspNetCoreMvcProblemDetails;
export type GetApiRequestsSentRequestsApiArg = {
    state?: SystemNullable601UserOrganizationManagementDomainEnumsERequestState20Domain20Version600020CultureNeutral20PublicKeyTokenNull;
    type?: SystemNullable601UserOrganizationManagementDomainEnumsERequestType20Domain20Version600020CultureNeutral20PublicKeyTokenNull;
    projectShortName?: SystemNullable601UserOrganizationManagementDomainValueObjectsProjectShortName20Domain20Version600020CultureNeutral20PublicKeyTokenNull;
};
export type PutApiRequestsByRequestIdAcceptApiResponse = unknown;
export type PutApiRequestsByRequestIdAcceptApiArg = {
    requestId: SystemGuid;
};
export type PutApiRequestsByRequestIdRejectApiResponse = unknown;
export type PutApiRequestsByRequestIdRejectApiArg = {
    requestId: SystemGuid;
    reason?: SystemString;
};
export type GetApiUserPreferencesApiResponse = /** status 200 OK */ SystemString;
export type GetApiUserPreferencesApiArg = void;
export type PutApiUserPreferencesApiResponse = /** status 200 OK */ SystemString;
export type PutApiUserPreferencesApiArg = {
    systemTextJsonJsonElement: SystemTextJsonJsonElement;
};
export type GetApiUserInfoApiResponse =
    /** status 200 OK */ UserOrganizationManagementDomainExtModelsUserOrgOutputModelsOthersUserInfoModel;
export type GetApiUserInfoApiArg = void;
export type GetApiUserInfoExtendedApiResponse =
    /** status 200 OK */ UserOrganizationManagementDomainExtModelsUserOrgOutputModelsOthersUserInfoExtendedModel;
export type GetApiUserInfoExtendedApiArg = void;
export type SyncDetailsApiResponse =
    /** status 200 OK */ SystemCollectionsGenericIList601UserOrganizationManagementDomainExtModelsUserOrgOutputModelsOthersUserInfoExtendedModel20Domain20Version600020CultureNeutral20PublicKeyTokenNull;
export type SyncDetailsApiArg = void;
export type ProjectsInfoApiResponse =
    /** status 200 OK */ SystemCollectionsGenericIEnumerable601UserOrganizationManagementDomainExtModelsUserOrgOutputModelsServiceProjectInfoModel20Domain20Version600020CultureNeutral20PublicKeyTokenNull;
export type ProjectsInfoApiArg = void;
export type WorkerDataApiResponse =
    /** status 200 OK */ UserOrganizationManagementApiApiDataStagingLocationEndpointDataStagingDataModel;
export type WorkerDataApiArg = void;
export type PostApiPublicHandleByActionLinkApiResponse = unknown;
export type PostApiPublicHandleByActionLinkApiArg = {
    actionLink: SystemString;
};
export type GetApiPublicRequestInfoByRequestIdApiResponse =
    /** status 200 OK */ UserOrganizationManagementDomainExtModelsUserOrgOutputModelsRequestPublicRequestModel;
export type GetApiPublicRequestInfoByRequestIdApiArg = {
    requestId: SystemGuid;
};
export type GetVersionApiResponse = /** status 200 OK */ SystemString;
export type GetVersionApiArg = void;
export type GetCommandTemplatePermissionsApiResponse =
    /** status 200 OK */ HeappeFeaturesCommandTemplatePermissionsResponseUserCommandTemplatePermissionModel;
export type GetCommandTemplatePermissionsApiArg = {
    heappeIdentifier: SystemString;
};
export type GetCommandTemplatesApiResponse =
    /** status 200 OK */ SystemCollectionsGenericIList601HeappeFeaturesCommandTemplateManagementGetAllResponseCommandTemplateResponse20Heappe20Version600020CultureNeutral20PublicKeyTokenNull;
export type GetCommandTemplatesApiArg = {
    projectShortName: SystemString;
    projectResourceName: SystemString;
};
export type ActivateCommandTemplateApiResponse = unknown;
export type ActivateCommandTemplateApiArg = {
    heappeFeaturesCommandTemplateManagementRequestCommandTemplateActivateRequest: HeappeFeaturesCommandTemplateManagementRequestCommandTemplateActivateRequest;
};
export type DeactivateCommandTemplateApiResponse = unknown;
export type DeactivateCommandTemplateApiArg = {
    heappeFeaturesCommandTemplateManagementRequestCommandTemplateActivateRequest: HeappeFeaturesCommandTemplateManagementRequestCommandTemplateActivateRequest;
};
export type SyncCommandTemplateApiResponse = unknown;
export type SyncCommandTemplateApiArg = {
    heappeFeaturesCommandTemplateSynchronizationRequestCommandTemplateSyncRequest: HeappeFeaturesCommandTemplateSynchronizationRequestCommandTemplateSyncRequest;
};
export type MigrateApiResponse =
    /** status 200 OK */ HeappeFeaturesCommandTemplateMigrationCommandTemplateMigrationEndpointResponse;
export type MigrateApiArg = {
    projectShortName?: SystemString;
    dryRun?: SystemNullable601SystemBoolean20SystemPrivateCoreLib20Version1000020CultureNeutral20PublicKeyToken7Cec85D7Bea7798E;
};
export type SystemCollectionsGenericIEnumerable601SystemObject20SystemPrivateCoreLib20Version1000020CultureNeutral20PublicKeyToken7Cec85D7Bea7798E =
    any;
export type SystemString = string;
export type SystemNullable601SystemInt3220SystemPrivateCoreLib20Version1000020CultureNeutral20PublicKeyToken7Cec85D7Bea7798E =
    number | string;
export type MicrosoftAspNetCoreMvcProblemDetails = {
    Type?: null | SystemString;
    Title?: null | SystemString;
    Status?: null | SystemNullable601SystemInt3220SystemPrivateCoreLib20Version1000020CultureNeutral20PublicKeyToken7Cec85D7Bea7798E;
    Detail?: null | SystemString;
    Instance?: null | SystemString;
};
export type SystemString2 = SystemString[];
export type SystemCollectionsGenericIDictionary602SystemString20SystemPrivateCoreLib20Version1000020CultureNeutral20PublicKeyToken7Cec85D7Bea7798ESystemString20SystemPrivateCoreLib20Version1000020CultureNeutral20PublicKeyToken7Cec85D7Bea7798E =
    {
        [key: string]: SystemString2;
    };
export type MicrosoftAspNetCoreHttpHttpValidationProblemDetails = {
    Type?: null | SystemString;
    Title?: null | SystemString;
    Status?: null | SystemNullable601SystemInt3220SystemPrivateCoreLib20Version1000020CultureNeutral20PublicKeyToken7Cec85D7Bea7798E;
    Detail?: null | SystemString;
    Instance?: null | SystemString;
    Errors?: SystemCollectionsGenericIDictionary602SystemString20SystemPrivateCoreLib20Version1000020CultureNeutral20PublicKeyToken7Cec85D7Bea7798ESystemString20SystemPrivateCoreLib20Version1000020CultureNeutral20PublicKeyToken7Cec85D7Bea7798E;
};
export type HeappeContractsDownloadedFileModel = {
    FileName: null | SystemString;
    TextContent: null | SystemString;
};
export type SystemCollectionsGenericIDictionary602SystemString20SystemPrivateCoreLib20Version1000020CultureNeutral20PublicKeyToken7Cec85D7Bea7798EHeappeContractsDownloadedFileModel20HeappeContracts20Version600020CultureNeutral20PublicKeyTokenNull =
    {
        [key: string]: HeappeContractsDownloadedFileModel;
    };
export type UserOrganizationManagementDomainValueObjectsProjectShortName = string;
export type SystemInt64 = number | string;
export type UserOrganizationManagementDomainExtModelsUserOrgOutputModelsOthersCountryModel = {
    Code?: null | SystemString;
    Name?: null | SystemString;
};
export type SystemCollectionsGenericIEnumerable601UserOrganizationManagementDomainExtModelsUserOrgOutputModelsOthersCountryModel20Domain20Version600020CultureNeutral20PublicKeyTokenNull =
    UserOrganizationManagementDomainExtModelsUserOrgOutputModelsOthersCountryModel[];
export type SystemInt32 = number | string;
export type SystemDateOnly = string;
export type UserOrganizationManagementDomainExtModelsUserOrgOutputModelsOthersWeeklyDataModel = {
    From: SystemDateOnly;
    To: SystemDateOnly;
    ProjectsCreated: SystemInt32;
    UsersCreated: SystemInt32;
    ResourcesCreated: SystemInt32;
};
export type SystemCollectionsGenericIList601UserOrganizationManagementDomainExtModelsUserOrgOutputModelsOthersWeeklyDataModel20Domain20Version600020CultureNeutral20PublicKeyTokenNull =
    UserOrganizationManagementDomainExtModelsUserOrgOutputModelsOthersWeeklyDataModel[];
export type UserOrganizationManagementDomainExtModelsUserOrgOutputModelsOthersStatisticsModel = {
    NumberOfProjects: SystemInt32;
    NumberOfUsers: SystemInt32;
    NumberOfResources: SystemInt32;
    WeeklyData: SystemCollectionsGenericIList601UserOrganizationManagementDomainExtModelsUserOrgOutputModelsOthersWeeklyDataModel20Domain20Version600020CultureNeutral20PublicKeyTokenNull;
};
export type SystemCollectionsGenericIEnumerable601UserOrganizationManagementDomainExtModelsUserOrgOutputModelsOthersStatisticsModel20Domain20Version600020CultureNeutral20PublicKeyTokenNull =
    UserOrganizationManagementDomainExtModelsUserOrgOutputModelsOthersStatisticsModel[];
export type SystemNullable601SystemDateOnly20SystemPrivateCoreLib20Version1000020CultureNeutral20PublicKeyToken7Cec85D7Bea7798E =
    string;
export type UserOrganizationManagementDomainExtModelsUserOrgOutputModelsProjectProjectUserModel = {
    IdpUserId: SystemString;
    Email: SystemString;
    RoleName: SystemString;
};
export type SystemCollectionsGenericIEnumerable601UserOrganizationManagementDomainExtModelsUserOrgOutputModelsProjectProjectUserModel20Domain20Version600020CultureNeutral20PublicKeyTokenNull =
    UserOrganizationManagementDomainExtModelsUserOrgOutputModelsProjectProjectUserModel[];
export type SystemNullable601UserOrganizationManagementDomainValueObjectsProjectId20Domain20Version600020CultureNeutral20PublicKeyTokenNull =
    any;
export type SystemNullable601SystemDateTime20SystemPrivateCoreLib20Version1000020CultureNeutral20PublicKeyToken7Cec85D7Bea7798E =
    string;
export type UserOrganizationManagementDomainExtModelsUserOrgOutputModelsEOperationModeResponse =
    | 'Unspecified'
    | 'ReadOnly'
    | 'Editable';
export type SystemGuid = string;
export type SystemCollectionsGenericIList601SystemGuid20SystemPrivateCoreLib20Version1000020CultureNeutral20PublicKeyToken7Cec85D7Bea7798E =
    SystemGuid[];
export type UserOrganizationManagementDomainExtModelsUserOrgOutputModelsProjectProjectModel = {
    Id?: null | SystemNullable601UserOrganizationManagementDomainValueObjectsProjectId20Domain20Version600020CultureNeutral20PublicKeyTokenNull;
    Name?: null | SystemString;
    ShortName?: null | SystemString;
    Description?: null | SystemString;
    ContactEmail?: null | SystemString;
    StartDate?: null | SystemNullable601SystemDateTime20SystemPrivateCoreLib20Version1000020CultureNeutral20PublicKeyToken7Cec85D7Bea7798E;
    EndDate?: null | SystemNullable601SystemDateTime20SystemPrivateCoreLib20Version1000020CultureNeutral20PublicKeyToken7Cec85D7Bea7798E;
    DomainId?: null | SystemNullable601SystemInt3220SystemPrivateCoreLib20Version1000020CultureNeutral20PublicKeyToken7Cec85D7Bea7798E;
    OperationMode?: UserOrganizationManagementDomainExtModelsUserOrgOutputModelsEOperationModeResponse;
    AssignedProjectResourceIds?: null | SystemCollectionsGenericIList601SystemGuid20SystemPrivateCoreLib20Version1000020CultureNeutral20PublicKeyToken7Cec85D7Bea7798E;
    AssignedTags?: null | SystemCollectionsGenericIList601SystemGuid20SystemPrivateCoreLib20Version1000020CultureNeutral20PublicKeyToken7Cec85D7Bea7798E;
};
export type SystemCollectionsGenericList601UserOrganizationManagementDomainExtModelsUserOrgOutputModelsProjectProjectModel20Domain20Version600020CultureNeutral20PublicKeyTokenNull =
    UserOrganizationManagementDomainExtModelsUserOrgOutputModelsProjectProjectModel[];
export type SystemNullable601UserOrganizationManagementDomainValueObjectsProjectShortName20Domain20Version600020CultureNeutral20PublicKeyTokenNull =
    any;
export type SystemDateTime = string;
export type UserOrganizationManagementDomainExtModelsUserOrgInputModelsProjectProjectCreate = {
    Name?: null | SystemString;
    ShortName?: null | SystemString;
    Description?: null | SystemString;
    ContactEmail?: null | SystemString;
    StartDate?: SystemDateTime;
    EndDate?: SystemDateTime;
    DomainId?: null | SystemNullable601SystemInt3220SystemPrivateCoreLib20Version1000020CultureNeutral20PublicKeyToken7Cec85D7Bea7798E;
};
export type UserOrganizationManagementDomainExtModelsUserOrgInputModelsProjectProjectUpdate = {
    Name?: null | SystemString;
    ShortName?: UserOrganizationManagementDomainValueObjectsProjectShortName;
    Description?: null | SystemString;
    ContactEmail?: null | SystemString;
    StartDate?: SystemDateTime;
    EndDate?: SystemDateTime;
    DomainId?: null | SystemNullable601SystemInt3220SystemPrivateCoreLib20Version1000020CultureNeutral20PublicKeyToken7Cec85D7Bea7798E;
};
export type SystemBoolean = boolean;
export type SystemNullable601SystemInt6420SystemPrivateCoreLib20Version1000020CultureNeutral20PublicKeyToken7Cec85D7Bea7798E =
    number | string;
export type UserOrganizationManagementDomainExtModelsUserOrgOutputModelsProjectTemplateParameterModel = {
    Identifier?: null | SystemString;
    Description?: null | SystemString;
};
export type SystemCollectionsGenericIEnumerable601UserOrganizationManagementDomainExtModelsUserOrgOutputModelsProjectTemplateParameterModel20Domain20Version600020CultureNeutral20PublicKeyTokenNull =
    UserOrganizationManagementDomainExtModelsUserOrgOutputModelsProjectTemplateParameterModel[];
export type UserOrganizationManagementDomainExtModelsUserOrgOutputModelsProjectCommandTemplate = {
    Id: SystemInt64;
    Name: SystemString;
    IsGeneric: SystemBoolean;
    Parameters: SystemCollectionsGenericIEnumerable601UserOrganizationManagementDomainExtModelsUserOrgOutputModelsProjectTemplateParameterModel20Domain20Version600020CultureNeutral20PublicKeyTokenNull;
};
export type SystemCollectionsGenericIEnumerable601UserOrganizationManagementDomainExtModelsUserOrgOutputModelsProjectCommandTemplate20Domain20Version600020CultureNeutral20PublicKeyTokenNull =
    UserOrganizationManagementDomainExtModelsUserOrgOutputModelsProjectCommandTemplate[];
export type UserOrganizationManagementDomainExtModelsUserOrgOutputModelsProjectNodeAllocation = {
    LexisResourceName: SystemString;
    CommandTemplates: SystemCollectionsGenericIEnumerable601UserOrganizationManagementDomainExtModelsUserOrgOutputModelsProjectCommandTemplate20Domain20Version600020CultureNeutral20PublicKeyTokenNull;
};
export type SystemCollectionsGenericIEnumerable601UserOrganizationManagementDomainExtModelsUserOrgOutputModelsProjectNodeAllocation20Domain20Version600020CultureNeutral20PublicKeyTokenNull =
    UserOrganizationManagementDomainExtModelsUserOrgOutputModelsProjectNodeAllocation[];
export type UserOrganizationManagementDomainExtModelsUserOrgOutputModelsProjectNodeInfo = {
    NodeId: SystemInt64;
    NodeType: SystemString;
    NumberOfNodes: null | SystemNullable601SystemInt3220SystemPrivateCoreLib20Version1000020CultureNeutral20PublicKeyToken7Cec85D7Bea7798E;
    ClusterPerNode: SystemInt32;
    MaxWallTime: SystemInt32;
    FileTransferMethodId: SystemInt32;
    Allocations: SystemCollectionsGenericIEnumerable601UserOrganizationManagementDomainExtModelsUserOrgOutputModelsProjectNodeAllocation20Domain20Version600020CultureNeutral20PublicKeyTokenNull;
};
export type SystemCollectionsGenericIEnumerable601UserOrganizationManagementDomainExtModelsUserOrgOutputModelsProjectNodeInfo20Domain20Version600020CultureNeutral20PublicKeyTokenNull =
    UserOrganizationManagementDomainExtModelsUserOrgOutputModelsProjectNodeInfo[];
export type UserOrganizationManagementDomainExtModelsUserOrgOutputModelsProjectTemplateInfoResponse = {
    IsAvailable: SystemBoolean;
    ClusterName: SystemString;
    LocationId: SystemString;
    ClusterId: null | SystemNullable601SystemInt6420SystemPrivateCoreLib20Version1000020CultureNeutral20PublicKeyToken7Cec85D7Bea7798E;
    Nodes: SystemCollectionsGenericIEnumerable601UserOrganizationManagementDomainExtModelsUserOrgOutputModelsProjectNodeInfo20Domain20Version600020CultureNeutral20PublicKeyTokenNull;
};
export type SystemCollectionsGenericList601UserOrganizationManagementDomainExtModelsUserOrgOutputModelsProjectTemplateInfoResponse20Domain20Version600020CultureNeutral20PublicKeyTokenNull =
    UserOrganizationManagementDomainExtModelsUserOrgOutputModelsProjectTemplateInfoResponse[];
export type SystemCollectionsGenericKeyValuePair602SystemString20SystemPrivateCoreLib20Version1000020CultureNeutral20PublicKeyToken7Cec85D7Bea7798ESystemString20SystemPrivateCoreLib20Version1000020CultureNeutral20PublicKeyToken7Cec85D7Bea7798E =
    {
        Key: SystemString;
        Value: SystemString;
    };
export type SystemCollectionsGenericIList601SystemCollectionsGenericKeyValuePair602SystemString20SystemPrivateCoreLib20Version1000020CultureNeutral20PublicKeyToken7Cec85D7Bea7798ESystemString20SystemPrivateCoreLib20Version1000020CultureNeutral20PublicKeyToken7Cec85D7Bea7798E20SystemPrivateCoreLib20Version1000020CultureNeutral20PublicKeyToken7Cec85D7Bea7798E =
    SystemCollectionsGenericKeyValuePair602SystemString20SystemPrivateCoreLib20Version1000020CultureNeutral20PublicKeyToken7Cec85D7Bea7798ESystemString20SystemPrivateCoreLib20Version1000020CultureNeutral20PublicKeyToken7Cec85D7Bea7798E[];
export type UserOrganizationManagementDomainExtModelsUserOrgOutputModelsProjectResourceAssignmentProjectResourceAssignmentExtendedModel =
    {
        ProjectResourceName?: null | SystemString;
        LocationName?: null | SystemString;
        AllocationAmount?: null | SystemNullable601SystemInt6420SystemPrivateCoreLib20Version1000020CultureNeutral20PublicKeyToken7Cec85D7Bea7798E;
        AllocationUnitTypeName?: null | SystemString;
        AggregationName?: null | SystemString;
        Specifications?: null | SystemCollectionsGenericIList601SystemCollectionsGenericKeyValuePair602SystemString20SystemPrivateCoreLib20Version1000020CultureNeutral20PublicKeyToken7Cec85D7Bea7798ESystemString20SystemPrivateCoreLib20Version1000020CultureNeutral20PublicKeyToken7Cec85D7Bea7798E20SystemPrivateCoreLib20Version1000020CultureNeutral20PublicKeyToken7Cec85D7Bea7798E;
        LocationTypeId?: SystemInt32;
    };
export type SystemCollectionsGenericIList601UserOrganizationManagementDomainExtModelsUserOrgOutputModelsProjectResourceAssignmentProjectResourceAssignmentExtendedModel20Domain20Version600020CultureNeutral20PublicKeyTokenNull =
    UserOrganizationManagementDomainExtModelsUserOrgOutputModelsProjectResourceAssignmentProjectResourceAssignmentExtendedModel[];
export type UserOrganizationManagementDomainExtModelsUserOrgOutputModelsProjectExtendedProjectModel = {
    Name?: null | SystemString;
    ShortName?: null | SystemString;
    Description?: null | SystemString;
    ContactEmail?: null | SystemString;
    StartDate?: null | SystemNullable601SystemDateTime20SystemPrivateCoreLib20Version1000020CultureNeutral20PublicKeyToken7Cec85D7Bea7798E;
    EndDate?: null | SystemNullable601SystemDateTime20SystemPrivateCoreLib20Version1000020CultureNeutral20PublicKeyToken7Cec85D7Bea7798E;
    DomainId?: null | SystemNullable601SystemInt3220SystemPrivateCoreLib20Version1000020CultureNeutral20PublicKeyToken7Cec85D7Bea7798E;
    AssignedProjectResources?: null | SystemCollectionsGenericIList601UserOrganizationManagementDomainExtModelsUserOrgOutputModelsProjectResourceAssignmentProjectResourceAssignmentExtendedModel20Domain20Version600020CultureNeutral20PublicKeyTokenNull;
    AssignedTags?: null | SystemCollectionsGenericIList601SystemGuid20SystemPrivateCoreLib20Version1000020CultureNeutral20PublicKeyToken7Cec85D7Bea7798E;
};
export type SystemCollectionsGenericList601UserOrganizationManagementDomainExtModelsUserOrgOutputModelsProjectExtendedProjectModel20Domain20Version600020CultureNeutral20PublicKeyTokenNull =
    UserOrganizationManagementDomainExtModelsUserOrgOutputModelsProjectExtendedProjectModel[];
export type SystemCollectionsGenericIList601SystemString20SystemPrivateCoreLib20Version1000020CultureNeutral20PublicKeyToken7Cec85D7Bea7798E =
    SystemString[];
export type UserOrganizationManagementDomainExtModelsUserOrgOutputModelsSystemRoleManagementSystemRoleModel = {
    Name: SystemString;
    Id: SystemInt32;
    Description: null | SystemString;
    SystemPermissions: SystemCollectionsGenericIList601SystemString20SystemPrivateCoreLib20Version1000020CultureNeutral20PublicKeyToken7Cec85D7Bea7798E;
};
export type SystemCollectionsGenericList601UserOrganizationManagementDomainExtModelsUserOrgOutputModelsSystemRoleManagementSystemRoleModel20Domain20Version600020CultureNeutral20PublicKeyTokenNull =
    UserOrganizationManagementDomainExtModelsUserOrgOutputModelsSystemRoleManagementSystemRoleModel[];
export type SystemNullable601SystemGuid20SystemPrivateCoreLib20Version1000020CultureNeutral20PublicKeyToken7Cec85D7Bea7798E =
    string;
export type UserOrganizationManagementDomainExtModelsUserOrgOutputModelsProjectResourceAssignmentProjectResourceAssignmentModel =
    {
        Id?: null | SystemNullable601SystemGuid20SystemPrivateCoreLib20Version1000020CultureNeutral20PublicKeyToken7Cec85D7Bea7798E;
        ProjectResourceId?: null | SystemNullable601SystemGuid20SystemPrivateCoreLib20Version1000020CultureNeutral20PublicKeyToken7Cec85D7Bea7798E;
        LocationId?: null | SystemNullable601SystemGuid20SystemPrivateCoreLib20Version1000020CultureNeutral20PublicKeyToken7Cec85D7Bea7798E;
        LocationTypeId?: SystemInt32;
        IsLocationShared?: SystemBoolean;
        LocationName: SystemString;
        AllocationAmount?: null | SystemNullable601SystemInt6420SystemPrivateCoreLib20Version1000020CultureNeutral20PublicKeyToken7Cec85D7Bea7798E;
        AllocationUnitTypeId?: null | SystemNullable601SystemInt3220SystemPrivateCoreLib20Version1000020CultureNeutral20PublicKeyToken7Cec85D7Bea7798E;
        AggregationName?: null | SystemString;
        OperationMode?: UserOrganizationManagementDomainExtModelsUserOrgOutputModelsEOperationModeResponse;
        Specifications?: null | SystemCollectionsGenericIList601SystemCollectionsGenericKeyValuePair602SystemString20SystemPrivateCoreLib20Version1000020CultureNeutral20PublicKeyToken7Cec85D7Bea7798ESystemString20SystemPrivateCoreLib20Version1000020CultureNeutral20PublicKeyToken7Cec85D7Bea7798E20SystemPrivateCoreLib20Version1000020CultureNeutral20PublicKeyToken7Cec85D7Bea7798E;
    };
export type SystemCollectionsGenericIEnumerable601UserOrganizationManagementDomainExtModelsUserOrgOutputModelsProjectResourceAssignmentProjectResourceAssignmentModel20Domain20Version600020CultureNeutral20PublicKeyTokenNull =
    UserOrganizationManagementDomainExtModelsUserOrgOutputModelsProjectResourceAssignmentProjectResourceAssignmentModel[];
export type UserOrganizationManagementDomainExtModelsUserOrgInputModelsProjectResourceAssignmentProjectResourceAssignmentCreate =
    {
        ProjectResourceId?: null | SystemNullable601SystemGuid20SystemPrivateCoreLib20Version1000020CultureNeutral20PublicKeyToken7Cec85D7Bea7798E;
        LocationId?: null | SystemNullable601SystemGuid20SystemPrivateCoreLib20Version1000020CultureNeutral20PublicKeyToken7Cec85D7Bea7798E;
        AllocationAmount?: null | SystemNullable601SystemInt6420SystemPrivateCoreLib20Version1000020CultureNeutral20PublicKeyToken7Cec85D7Bea7798E;
        AllocationUnitTypeId?: null | SystemNullable601SystemInt3220SystemPrivateCoreLib20Version1000020CultureNeutral20PublicKeyToken7Cec85D7Bea7798E;
        AggregationName?: null | SystemString;
        Specifications?: null | SystemCollectionsGenericIList601SystemCollectionsGenericKeyValuePair602SystemString20SystemPrivateCoreLib20Version1000020CultureNeutral20PublicKeyToken7Cec85D7Bea7798ESystemString20SystemPrivateCoreLib20Version1000020CultureNeutral20PublicKeyToken7Cec85D7Bea7798E20SystemPrivateCoreLib20Version1000020CultureNeutral20PublicKeyToken7Cec85D7Bea7798E;
    };
export type UserOrganizationManagementDomainExtModelsUserOrgInputModelsProjectResourceAssignmentProjectResourceAssignmentUpdate =
    {
        Id?: null | SystemNullable601SystemGuid20SystemPrivateCoreLib20Version1000020CultureNeutral20PublicKeyToken7Cec85D7Bea7798E;
        AllocationAmount?: null | SystemNullable601SystemInt6420SystemPrivateCoreLib20Version1000020CultureNeutral20PublicKeyToken7Cec85D7Bea7798E;
        AllocationUnitTypeId?: null | SystemNullable601SystemInt3220SystemPrivateCoreLib20Version1000020CultureNeutral20PublicKeyToken7Cec85D7Bea7798E;
        AggregationName?: null | SystemString;
        Specifications?: null | SystemCollectionsGenericIList601SystemCollectionsGenericKeyValuePair602SystemString20SystemPrivateCoreLib20Version1000020CultureNeutral20PublicKeyToken7Cec85D7Bea7798ESystemString20SystemPrivateCoreLib20Version1000020CultureNeutral20PublicKeyToken7Cec85D7Bea7798E20SystemPrivateCoreLib20Version1000020CultureNeutral20PublicKeyToken7Cec85D7Bea7798E;
        Description?: null | SystemString;
    };
export type SystemCollectionsGenericIList601UserOrganizationManagementDomainExtModelsUserOrgOutputModelsProjectResourceAssignmentProjectResourceAssignmentModel20Domain20Version600020CultureNeutral20PublicKeyTokenNull =
    UserOrganizationManagementDomainExtModelsUserOrgOutputModelsProjectResourceAssignmentProjectResourceAssignmentModel[];
export type UserOrganizationManagementDomainExtModelsUserOrgOutputModelsProjectResourceProjectResourceModel = {
    Id?: null | SystemNullable601SystemGuid20SystemPrivateCoreLib20Version1000020CultureNeutral20PublicKeyToken7Cec85D7Bea7798E;
    Name?: null | SystemString;
    Description?: null | SystemString;
    PrimaryInvestigatorEmail?: null | SystemString;
    StartDate?: null | SystemNullable601SystemDateTime20SystemPrivateCoreLib20Version1000020CultureNeutral20PublicKeyToken7Cec85D7Bea7798E;
    EndDate?: null | SystemNullable601SystemDateTime20SystemPrivateCoreLib20Version1000020CultureNeutral20PublicKeyToken7Cec85D7Bea7798E;
    OperationMode?: UserOrganizationManagementDomainExtModelsUserOrgOutputModelsEOperationModeResponse;
    Assignments?: null | SystemCollectionsGenericIList601UserOrganizationManagementDomainExtModelsUserOrgOutputModelsProjectResourceAssignmentProjectResourceAssignmentModel20Domain20Version600020CultureNeutral20PublicKeyTokenNull;
};
export type SystemCollectionsGenericIEnumerable601UserOrganizationManagementDomainExtModelsUserOrgOutputModelsProjectResourceProjectResourceModel20Domain20Version600020CultureNeutral20PublicKeyTokenNull =
    UserOrganizationManagementDomainExtModelsUserOrgOutputModelsProjectResourceProjectResourceModel[];
export type UserOrganizationManagementDomainExtModelsUserOrgInputModelsProjectResourceProjectResourceCreate = {
    Name?: null | SystemString;
    Description?: null | SystemString;
    PrimaryInvestigatorEmail?: null | SystemString;
    StartDate?: null | SystemNullable601SystemDateTime20SystemPrivateCoreLib20Version1000020CultureNeutral20PublicKeyToken7Cec85D7Bea7798E;
    EndDate?: null | SystemNullable601SystemDateTime20SystemPrivateCoreLib20Version1000020CultureNeutral20PublicKeyToken7Cec85D7Bea7798E;
};
export type UserOrganizationManagementDomainExtModelsUserOrgInputModelsProjectResourceProjectResourceUpdate = {
    Id?: null | SystemNullable601SystemGuid20SystemPrivateCoreLib20Version1000020CultureNeutral20PublicKeyToken7Cec85D7Bea7798E;
    Name?: null | SystemString;
    Description?: null | SystemString;
    PrimaryInvestigatorEmail?: null | SystemString;
    StartDate?: null | SystemNullable601SystemDateTime20SystemPrivateCoreLib20Version1000020CultureNeutral20PublicKeyToken7Cec85D7Bea7798E;
    EndDate?: null | SystemNullable601SystemDateTime20SystemPrivateCoreLib20Version1000020CultureNeutral20PublicKeyToken7Cec85D7Bea7798E;
};
export type UserOrganizationManagementDomainExtModelsUserOrgOutputModelsProjectTagProjectTagModel = {
    Id?: null | SystemNullable601SystemGuid20SystemPrivateCoreLib20Version1000020CultureNeutral20PublicKeyToken7Cec85D7Bea7798E;
    Name?: null | SystemString;
    Description?: null | SystemString;
};
export type SystemCollectionsGenericIEnumerable601UserOrganizationManagementDomainExtModelsUserOrgOutputModelsProjectTagProjectTagModel20Domain20Version600020CultureNeutral20PublicKeyTokenNull =
    UserOrganizationManagementDomainExtModelsUserOrgOutputModelsProjectTagProjectTagModel[];
export type UserOrganizationManagementDomainExtModelsUserOrgInputModelsProjectTagProjectTagCreate = {
    Name?: null | SystemString;
    Description?: null | SystemString;
};
export type UserOrganizationManagementDomainExtModelsUserOrgInputModelsProjectTagProjectTagUpdate = {
    Id?: null | SystemNullable601SystemGuid20SystemPrivateCoreLib20Version1000020CultureNeutral20PublicKeyToken7Cec85D7Bea7798E;
    Name?: null | SystemString;
    Description?: null | SystemString;
};
export type UserOrganizationManagementDomainExtModelsUserOrgOutputModelsRequestRequestModel = {
    RequestId?: null | SystemNullable601SystemGuid20SystemPrivateCoreLib20Version1000020CultureNeutral20PublicKeyToken7Cec85D7Bea7798E;
    IdpUserId?: null | SystemString;
    UserName?: null | SystemString;
    Email?: null | SystemString;
    ProjectShortName?: null | SystemNullable601UserOrganizationManagementDomainValueObjectsProjectShortName20Domain20Version600020CultureNeutral20PublicKeyTokenNull;
    State?: null | SystemNullable601SystemInt3220SystemPrivateCoreLib20Version1000020CultureNeutral20PublicKeyToken7Cec85D7Bea7798E;
    Type?: SystemInt32;
    LastModification?: SystemDateTime;
};
export type SystemCollectionsGenericList601UserOrganizationManagementDomainExtModelsUserOrgOutputModelsRequestRequestModel20Domain20Version600020CultureNeutral20PublicKeyTokenNull =
    UserOrganizationManagementDomainExtModelsUserOrgOutputModelsRequestRequestModel[];
export type SystemNullable601UserOrganizationManagementDomainEnumsERequestState20Domain20Version600020CultureNeutral20PublicKeyTokenNull =
    'Pending' | 'PendingForPIAccept' | 'PendingForHPCProject' | 'Accepted' | 'Rejected' | null;
export type SystemNullable601UserOrganizationManagementDomainEnumsERequestType20Domain20Version600020CultureNeutral20PublicKeyTokenNull =
    'Unknown' | 'SelfOnboarding' | 'ProjectResourceAssignment' | 'HEAppECreation' | null;
export type UserOrganizationManagementDomainEnumsERequestType =
    | 'Unknown'
    | 'SelfOnboarding'
    | 'ProjectResourceAssignment'
    | 'HEAppECreation';
export type UserOrganizationManagementDomainExtModelsUserOrgInputModelsProjectRequestCreate = {
    ProjectShortName: UserOrganizationManagementDomainValueObjectsProjectShortName;
    RequestType: UserOrganizationManagementDomainEnumsERequestType;
    ProjectResourceName: null | SystemString;
    ProviderId: null | SystemNullable601SystemGuid20SystemPrivateCoreLib20Version1000020CultureNeutral20PublicKeyToken7Cec85D7Bea7798E;
    ContactEmail: null | SystemString;
};
export type SystemTextJsonJsonElement = any;
export type UserOrganizationManagementDomainExtModelsUserOrgOutputModelsUserPermissionUserSystemRoleModel = {
    IdpUserId: SystemString;
    UserEmail: SystemString;
    RoleName: SystemString;
    ProjectShortName: UserOrganizationManagementDomainValueObjectsProjectShortName;
    SystemPermissionTypes: SystemCollectionsGenericIList601SystemString20SystemPrivateCoreLib20Version1000020CultureNeutral20PublicKeyToken7Cec85D7Bea7798E;
};
export type SystemCollectionsGenericIList601UserOrganizationManagementDomainExtModelsUserOrgOutputModelsUserPermissionUserSystemRoleModel20Domain20Version600020CultureNeutral20PublicKeyTokenNull =
    UserOrganizationManagementDomainExtModelsUserOrgOutputModelsUserPermissionUserSystemRoleModel[];
export type UserOrganizationManagementDomainExtModelsUserOrgOutputModelsOthersUserInfoModel = {
    Id?: SystemGuid;
    KeycloakSid?: null | SystemString;
    Name?: null | SystemString;
    UserName?: null | SystemString;
    Email?: null | SystemString;
    SystemRoles?: SystemCollectionsGenericIList601UserOrganizationManagementDomainExtModelsUserOrgOutputModelsUserPermissionUserSystemRoleModel20Domain20Version600020CultureNeutral20PublicKeyTokenNull;
};
export type SystemCollectionsGenericIEnumerable601SystemCollectionsGenericKeyValuePair602SystemString20SystemPrivateCoreLib20Version1000020CultureNeutral20PublicKeyToken7Cec85D7Bea7798ESystemString20SystemPrivateCoreLib20Version1000020CultureNeutral20PublicKeyToken7Cec85D7Bea7798E20SystemPrivateCoreLib20Version1000020CultureNeutral20PublicKeyToken7Cec85D7Bea7798E =
    SystemCollectionsGenericKeyValuePair602SystemString20SystemPrivateCoreLib20Version1000020CultureNeutral20PublicKeyToken7Cec85D7Bea7798ESystemString20SystemPrivateCoreLib20Version1000020CultureNeutral20PublicKeyToken7Cec85D7Bea7798E[];
export type UserOrganizationManagementDomainExtModelsUserOrgOutputModelsUserPermissionLocationDetailModel = {
    Name: SystemString;
    Descritpion: SystemString;
    Endpoint: SystemString;
    IsPrivate: SystemBoolean;
    Type: SystemString;
    AllocationUnitCount: null | SystemNullable601SystemInt6420SystemPrivateCoreLib20Version1000020CultureNeutral20PublicKeyToken7Cec85D7Bea7798E;
    AllocationUnitType: SystemString;
    Values: SystemCollectionsGenericIEnumerable601SystemCollectionsGenericKeyValuePair602SystemString20SystemPrivateCoreLib20Version1000020CultureNeutral20PublicKeyToken7Cec85D7Bea7798ESystemString20SystemPrivateCoreLib20Version1000020CultureNeutral20PublicKeyToken7Cec85D7Bea7798E20SystemPrivateCoreLib20Version1000020CultureNeutral20PublicKeyToken7Cec85D7Bea7798E;
};
export type SystemCollectionsGenericIList601UserOrganizationManagementDomainExtModelsUserOrgOutputModelsUserPermissionLocationDetailModel20Domain20Version600020CultureNeutral20PublicKeyTokenNull =
    UserOrganizationManagementDomainExtModelsUserOrgOutputModelsUserPermissionLocationDetailModel[];
export type UserOrganizationManagementDomainExtModelsUserOrgOutputModelsUserPermissionProjectResourceDetailModel = {
    Name: SystemString;
    Description: SystemString;
    StartDate: null | SystemNullable601SystemDateTime20SystemPrivateCoreLib20Version1000020CultureNeutral20PublicKeyToken7Cec85D7Bea7798E;
    EndDate: null | SystemNullable601SystemDateTime20SystemPrivateCoreLib20Version1000020CultureNeutral20PublicKeyToken7Cec85D7Bea7798E;
    Locations: SystemCollectionsGenericIList601UserOrganizationManagementDomainExtModelsUserOrgOutputModelsUserPermissionLocationDetailModel20Domain20Version600020CultureNeutral20PublicKeyTokenNull;
};
export type SystemCollectionsGenericIEnumerable601UserOrganizationManagementDomainExtModelsUserOrgOutputModelsUserPermissionProjectResourceDetailModel20Domain20Version600020CultureNeutral20PublicKeyTokenNull =
    UserOrganizationManagementDomainExtModelsUserOrgOutputModelsUserPermissionProjectResourceDetailModel[];
export type UserOrganizationManagementDomainExtModelsUserOrgOutputModelsUserPermissionUserSystemRoleExtendedModel = {
    ProjectShortName: UserOrganizationManagementDomainValueObjectsProjectShortName;
    UserEmail: SystemString;
    RoleName: SystemString;
    ProjectResources: SystemCollectionsGenericIEnumerable601UserOrganizationManagementDomainExtModelsUserOrgOutputModelsUserPermissionProjectResourceDetailModel20Domain20Version600020CultureNeutral20PublicKeyTokenNull;
    SystemPermissionTypes: SystemCollectionsGenericIList601SystemString20SystemPrivateCoreLib20Version1000020CultureNeutral20PublicKeyToken7Cec85D7Bea7798E;
};
export type SystemCollectionsGenericIList601UserOrganizationManagementDomainExtModelsUserOrgOutputModelsUserPermissionUserSystemRoleExtendedModel20Domain20Version600020CultureNeutral20PublicKeyTokenNull =
    UserOrganizationManagementDomainExtModelsUserOrgOutputModelsUserPermissionUserSystemRoleExtendedModel[];
export type UserOrganizationManagementDomainExtModelsUserOrgOutputModelsOthersUserInfoExtendedModel = {
    Id?: SystemGuid;
    KeycloakSid?: null | SystemString;
    Name?: null | SystemString;
    UserName?: null | SystemString;
    Email?: null | SystemString;
    SystemRoles?: SystemCollectionsGenericIList601UserOrganizationManagementDomainExtModelsUserOrgOutputModelsUserPermissionUserSystemRoleExtendedModel20Domain20Version600020CultureNeutral20PublicKeyTokenNull;
};
export type SystemCollectionsGenericIList601UserOrganizationManagementDomainExtModelsUserOrgOutputModelsOthersUserInfoExtendedModel20Domain20Version600020CultureNeutral20PublicKeyTokenNull =
    UserOrganizationManagementDomainExtModelsUserOrgOutputModelsOthersUserInfoExtendedModel[];
export type UserOrganizationManagementDomainExtModelsUserOrgOutputModelsProjectResourceAssociatedProjectModel = {
    Id: SystemGuid;
    ShortName: SystemString;
    CollectorName: SystemString;
    StartDate: null | SystemNullable601SystemDateTime20SystemPrivateCoreLib20Version1000020CultureNeutral20PublicKeyToken7Cec85D7Bea7798E;
    EndDate: null | SystemNullable601SystemDateTime20SystemPrivateCoreLib20Version1000020CultureNeutral20PublicKeyToken7Cec85D7Bea7798E;
};
export type SystemCollectionsGenericIList601UserOrganizationManagementDomainExtModelsUserOrgOutputModelsProjectResourceAssociatedProjectModel20Domain20Version600020CultureNeutral20PublicKeyTokenNull =
    UserOrganizationManagementDomainExtModelsUserOrgOutputModelsProjectResourceAssociatedProjectModel[];
export type UserOrganizationManagementDomainExtModelsUserOrgOutputModelsProjectResourceAssignmentProjectResourceAssignmentServiceModel =
    {
        LocationName?: null | SystemString;
        LocationDescription?: null | SystemString;
        ResourceType?: null | SystemString;
        AllocationAmount?: null | SystemNullable601SystemInt6420SystemPrivateCoreLib20Version1000020CultureNeutral20PublicKeyToken7Cec85D7Bea7798E;
        AllocationUnitTypeName?: null | SystemString;
        AggregationName?: null | SystemString;
        Specifications?: null | SystemCollectionsGenericIList601SystemCollectionsGenericKeyValuePair602SystemString20SystemPrivateCoreLib20Version1000020CultureNeutral20PublicKeyToken7Cec85D7Bea7798ESystemString20SystemPrivateCoreLib20Version1000020CultureNeutral20PublicKeyToken7Cec85D7Bea7798E20SystemPrivateCoreLib20Version1000020CultureNeutral20PublicKeyToken7Cec85D7Bea7798E;
    };
export type SystemCollectionsGenericIList601UserOrganizationManagementDomainExtModelsUserOrgOutputModelsProjectResourceAssignmentProjectResourceAssignmentServiceModel20Domain20Version600020CultureNeutral20PublicKeyTokenNull =
    UserOrganizationManagementDomainExtModelsUserOrgOutputModelsProjectResourceAssignmentProjectResourceAssignmentServiceModel[];
export type UserOrganizationManagementDomainExtModelsUserOrgOutputModelsProjectResourceProjectResourceServiceModel = {
    Id?: null | SystemNullable601SystemGuid20SystemPrivateCoreLib20Version1000020CultureNeutral20PublicKeyToken7Cec85D7Bea7798E;
    Name?: null | SystemString;
    Description?: null | SystemString;
    StartDate?: null | SystemNullable601SystemDateTime20SystemPrivateCoreLib20Version1000020CultureNeutral20PublicKeyToken7Cec85D7Bea7798E;
    EndDate?: null | SystemNullable601SystemDateTime20SystemPrivateCoreLib20Version1000020CultureNeutral20PublicKeyToken7Cec85D7Bea7798E;
    AssociatedProjects?: null | SystemCollectionsGenericIList601UserOrganizationManagementDomainExtModelsUserOrgOutputModelsProjectResourceAssociatedProjectModel20Domain20Version600020CultureNeutral20PublicKeyTokenNull;
    Assignments?: null | SystemCollectionsGenericIList601UserOrganizationManagementDomainExtModelsUserOrgOutputModelsProjectResourceAssignmentProjectResourceAssignmentServiceModel20Domain20Version600020CultureNeutral20PublicKeyTokenNull;
};
export type SystemCollectionsGenericIList601UserOrganizationManagementDomainExtModelsUserOrgOutputModelsProjectResourceProjectResourceServiceModel20Domain20Version600020CultureNeutral20PublicKeyTokenNull =
    UserOrganizationManagementDomainExtModelsUserOrgOutputModelsProjectResourceProjectResourceServiceModel[];
export type UserOrganizationManagementDomainExtModelsUserOrgOutputModelsServiceProjectInfoModel = {
    ProviderId?: null | SystemString;
    ProviderName?: null | SystemString;
    ProviderDescription?: null | SystemString;
    Resources?: null | SystemCollectionsGenericIList601UserOrganizationManagementDomainExtModelsUserOrgOutputModelsProjectResourceProjectResourceServiceModel20Domain20Version600020CultureNeutral20PublicKeyTokenNull;
};
export type SystemCollectionsGenericIEnumerable601UserOrganizationManagementDomainExtModelsUserOrgOutputModelsServiceProjectInfoModel20Domain20Version600020CultureNeutral20PublicKeyTokenNull =
    UserOrganizationManagementDomainExtModelsUserOrgOutputModelsServiceProjectInfoModel[];
export type UserOrganizationManagementApiApiDataStagingLocationEndpointDataStagingPart = {
    Name: SystemString;
    JsonData: SystemString;
};
export type UserOrganizationManagementApiApiDataStagingLocationEndpointDataStagingDataModel = {
    Name: SystemString;
    PublicData: UserOrganizationManagementApiApiDataStagingLocationEndpointDataStagingPart;
    PrivateData: UserOrganizationManagementApiApiDataStagingLocationEndpointDataStagingPart;
};
export type UserOrganizationManagementDomainExtModelsUserOrgOutputModelsRequestPublicRequestModel = {
    RequestId?: null | SystemNullable601SystemGuid20SystemPrivateCoreLib20Version1000020CultureNeutral20PublicKeyToken7Cec85D7Bea7798E;
    RequestorUserName?: null | SystemString;
    RequestorEmail?: null | SystemString;
    ProjectShortName?: UserOrganizationManagementDomainValueObjectsProjectShortName;
    ProjectResourceName?: null | SystemString;
    ProviderName?: null | SystemString;
    RequestState?: SystemInt32;
    ValidTo?: SystemDateTime;
    RequestType?: SystemInt32;
    AcceptActionLink?: null | SystemString;
    RejectActionLink?: null | SystemString;
};
export type HeappeFeaturesCommandTemplatePermissionsResponseCommandTemplateModel = {
    Name: SystemString;
    Enabled: SystemBoolean;
};
export type SystemCollectionsGenericIEnumerable601HeappeFeaturesCommandTemplatePermissionsResponseCommandTemplateModel20Heappe20Version600020CultureNeutral20PublicKeyTokenNull =
    HeappeFeaturesCommandTemplatePermissionsResponseCommandTemplateModel[];
export type HeappeFeaturesCommandTemplatePermissionsResponsePermissionModel = {
    QueueName: SystemString;
    ProjectResource: SystemString;
    ClusterName: SystemString;
    ProjectShortName: SystemString;
    CommandTemplates: SystemCollectionsGenericIEnumerable601HeappeFeaturesCommandTemplatePermissionsResponseCommandTemplateModel20Heappe20Version600020CultureNeutral20PublicKeyTokenNull;
};
export type SystemCollectionsGenericIEnumerable601HeappeFeaturesCommandTemplatePermissionsResponsePermissionModel20Heappe20Version600020CultureNeutral20PublicKeyTokenNull =
    HeappeFeaturesCommandTemplatePermissionsResponsePermissionModel[];
export type HeappeFeaturesCommandTemplatePermissionsResponseUserCommandTemplatePermissionModel = {
    HeappeIdentifikator: SystemString;
    Permissions: SystemCollectionsGenericIEnumerable601HeappeFeaturesCommandTemplatePermissionsResponsePermissionModel20Heappe20Version600020CultureNeutral20PublicKeyTokenNull;
};
export type HeappeFeaturesCommandTemplateManagementGetAllResponseECommandTemplateTypeResponse =
    | 'Unknown'
    | 'SystemDefined'
    | 'UserDefined';
export type HeappeFeaturesCommandTemplateManagementGetAllResponseECommandTemplateStateResponse = string;
export type HeappeFeaturesCommandTemplateManagementGetAllResponseCommandTemplateResponse = {
    Id: SystemGuid;
    Name: SystemString;
    Type: HeappeFeaturesCommandTemplateManagementGetAllResponseECommandTemplateTypeResponse;
    State: HeappeFeaturesCommandTemplateManagementGetAllResponseECommandTemplateStateResponse;
};
export type SystemCollectionsGenericIList601HeappeFeaturesCommandTemplateManagementGetAllResponseCommandTemplateResponse20Heappe20Version600020CultureNeutral20PublicKeyTokenNull =
    HeappeFeaturesCommandTemplateManagementGetAllResponseCommandTemplateResponse[];
export type HeappeFeaturesCommandTemplateManagementRequestCommandTemplateActivateRequest = {
    Id: SystemGuid;
    ProjectShortName?: SystemString;
    ResourceName?: SystemString;
};
export type HeappeFeaturesCommandTemplateSynchronizationRequestCommandTemplateSyncRequest = {
    ProjectShortName?: SystemString;
    ResourceName?: SystemString;
};
export type HeappeFeaturesCommandTemplateMigrationCommandTemplateMigrationEndpointCommandTemplateMigrationSummary = {
    ProjectShortName: SystemString;
    OriginalCommandTemplateName: SystemString;
    OriginalCommandTemplateId: SystemInt64;
    NewCommandTemplateName: SystemString;
    NewCommandTemplateId: SystemInt64;
    ResourceName: SystemString;
    CommandTemplateName: SystemString;
    DryRun: SystemBoolean;
    Outcome: SystemString;
    Details: SystemString;
};
export type SystemCollectionsGenericIReadOnlyList601HeappeFeaturesCommandTemplateMigrationCommandTemplateMigrationEndpointCommandTemplateMigrationSummary20Heappe20Version600020CultureNeutral20PublicKeyTokenNull =
    HeappeFeaturesCommandTemplateMigrationCommandTemplateMigrationEndpointCommandTemplateMigrationSummary[];
export type HeappeFeaturesCommandTemplateMigrationCommandTemplateMigrationEndpointResponse = {
    Summaries: SystemCollectionsGenericIReadOnlyList601HeappeFeaturesCommandTemplateMigrationCommandTemplateMigrationEndpointCommandTemplateMigrationSummary20Heappe20Version600020CultureNeutral20PublicKeyTokenNull;
};
export type SystemNullable601SystemBoolean20SystemPrivateCoreLib20Version1000020CultureNeutral20PublicKeyToken7Cec85D7Bea7798E =
    boolean;
export const {
    useGetApiEnumsRequestStatesQuery,
    useGetApiEnumsRequestTypesQuery,
    useGetApiEnumsOperationModeResponsesQuery,
    useGetApiHeappeListChangedFilesForJobByProjectShortNameAndResourceNameSubmittedJobInfoIdQuery,
    useGetApiOtherCountryQuery,
    useGetApiOtherStatisticsQuery,
    useGetApiOtherCyclopsUsageByProjectShortNameAndResourceNameQuery,
    useGetApiProjectByProjectShortNameUsersQuery,
    useGetProjectQuery,
    usePostApiProjectMutation,
    usePutApiProjectMutation,
    usePutApiProjectByProjectShortNameUserAndIdpUserIdAssignRoleIdMutation,
    useDeleteApiProjectByProjectShortNameMutation,
    usePutApiProjectByProjectShortNameProjectResourceAndProjectResourceNameMutation,
    useDeleteApiProjectByProjectShortNameProjectResourceAndProjectResourceNameMutation,
    usePutApiProjectByProjectShortNameUserAndIdpUserIdMutation,
    useDeleteApiProjectByProjectShortNameUserAndIdpUserIdMutation,
    usePutApiProjectByProjectShortNameProjectTagAndProjectTagIdMutation,
    useDeleteApiProjectByProjectShortNameProjectTagAndProjectTagIdMutation,
    useTemplatesInfoQuery,
    useExtendedProjectInfoQuery,
    useValidRolesQuery,
    useGetApiProjectResourceAssignmentQuery,
    usePostApiProjectResourceAssignmentMutation,
    usePutApiProjectResourceAssignmentMutation,
    useGetProjectResourceAssignmentQuery,
    useDeleteApiProjectResourceAssignmentByIdMutation,
    useGetApiProjectResourceQuery,
    usePostApiProjectResourceMutation,
    usePutApiProjectResourceMutation,
    useGetProjectResourceQuery,
    useDeleteApiProjectResourceByIdMutation,
    useGetApiProjectTagQuery,
    usePostApiProjectTagMutation,
    usePutApiProjectTagMutation,
    useGetProjectTagQuery,
    useDeleteApiProjectTagByIdMutation,
    useGetApiRequestsQuery,
    usePostApiRequestsMutation,
    useGetApiRequestsSentRequestsQuery,
    usePutApiRequestsByRequestIdAcceptMutation,
    usePutApiRequestsByRequestIdRejectMutation,
    useGetApiUserPreferencesQuery,
    usePutApiUserPreferencesMutation,
    useGetApiUserInfoQuery,
    useGetApiUserInfoExtendedQuery,
    useSyncDetailsQuery,
    useProjectsInfoQuery,
    useWorkerDataQuery,
    usePostApiPublicHandleByActionLinkMutation,
    useGetApiPublicRequestInfoByRequestIdQuery,
    useGetVersionQuery,
    useGetCommandTemplatePermissionsQuery,
    useGetCommandTemplatesQuery,
    useActivateCommandTemplateMutation,
    useDeactivateCommandTemplateMutation,
    useSyncCommandTemplateMutation,
    useMigrateMutation,
} = injectedRtkApi;
